import { Map } from 'immutable';
import { actions } from '../constants';

const initialState = Map({
  user: new Map(),
  sessionToken: null
});

export default function auth(state = initialState, action = null) {
  const { type, payload } = action;
  switch ( type ) {
    case actions.LOGIN_COMPLETED:
    case actions.SIGNUP_COMPLETED:
      return state.merge({
        user: payload.account,
        sessionToken: payload.sessionToken
      });
    case actions.LOAD_SESSION:
      return state.merge({
        user: payload.account,
        sessionToken: payload.sessionToken
      });
    case actions.CLEAR_SESSION:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js